module.exports = __webpack_public_path__ + "static/img/banner@3x.b802e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner@3x.png
// module id = 8Kpf
// module chunks = 1